export default __webpack_public_path__ + "static/media/JOSA CLASS-10 EXAM PATTERN 2026-27.3c92ebef.pdf";